import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProfileService {
    private readonly baseUrl = '/api/iam/users';

    constructor(private http: HttpClient) { }

    updateProfile(userId: string, firstName: string, lastName: string): Observable<any> {
        return this.http.put(`${this.baseUrl}/${userId}`, { first_name: firstName, last_name: lastName });
    }

    sendReset(email: string): Observable<any> {
        return this.http.post(`${this.baseUrl}/reset`, { email });
    }
}